import Skeleton from '@material-ui/lab/Skeleton'
import React, { memo } from 'react'

export interface TableLoadingSkeletonProps {
    height: number
    pageSize: number
}

const TableLoadingSkeleton = ({
    height,
    pageSize,
}: TableLoadingSkeletonProps) => {
    return (
        <>
            {Array.from(Array(pageSize)).map((_, idx) => (
                <div
                    className="tr spectable-loading"
                    key={`spectable-loading-${idx}`}
                    role="row"
                    aria-label="loading data row"
                >
                    <Skeleton variant="text" height={height} />
                </div>
            ))}
        </>
    )
}

export default memo(TableLoadingSkeleton)
